import React from "react";
import Benefits from "./views/Benefits";

const App = ({ video }) => {
    return <Benefits video={video} />;
};

export default App;
